import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M6.76 15.322 5.322 4.906a.833.833 0 0 1 .825-.948h8.505c.505 0 .894.447.825.948L14.04 15.322a.833.833 0 0 1-.825.72h-5.63a.833.833 0 0 1-.825-.72Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M6.234 10S7.9 8.333 10.4 10c2.5 1.667 4.167 0 4.167 0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);